import cn from "classnames";

export const DataGridHead: React.FC<{ className?: string; children: React.ReactNode }> = ({ className, children }) => {
    return <thead className={cn("data-grid-head", className)}>{children}</thead>;
};
